export default __webpack_public_path__ + "static/media/icon-coin-ilv.f61579a1.svg";